export const advertismentContentType = ["text", "banner", "bannerAndText"] as const;
export type AdvertismentContentType = typeof advertismentContentType[number];
